import { Zastosowanie } from "./Zastosowanie";
import { createRevisionClassResource, RevisionActions } from "../../revision";
import { Ingredient, getIngredientsDiff } from "./Ingredient";
import { RevisionItem } from "../RevisionItem";
import {
  apiField,
  constructFromApiData,
  getApiPostData,
  getDiff,
  decimalApiField,
  nestedItemArrayApiField,
} from "../ResourceItemMetadata";
import { ItemDiff, ResourceItem } from "../ResourceItem";
import { Resource } from "../../resource";
import { CsvActions, createCsvResource } from "../../csvList";
import Decimal from "decimal.js";
import { getNestedListDiff } from "../diff";

export class Receptura extends RevisionItem {
  @apiField()
  name!: string;

  @nestedItemArrayApiField(Zastosowanie, {
    getDiff: getNestedListDiff<Zastosowanie>(
      (a, b) => a.getDiff(b),
      (z) => z.category.id!,
    ),
  })
  zastosowania: Zastosowanie[] = [];

  @decimalApiField()
  defaultMassKg: Decimal = new Decimal(1000);

  @apiField({
    inputTransform: (ingredients) =>
      ingredients.map((s: any) => new Ingredient(s)),
    outputTransform: (ingredients) =>
      ingredients.map((s: any) => s.getPostData()),
    getDiff: getIngredientsDiff,
  })
  ingredients: Ingredient[] = [];

  @apiField({ readOnly: true })
  activeProduktSet: ResourceItem[] | null = null;

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }

  toString(): string {
    return this.id ? this.id.toString() : "Nowa receptura";
  }

  getPostData(): any {
    return {
      ...super.getPostData(),
      ...getApiPostData(this),
    };
  }

  getDiff(other: this): ItemDiff<Receptura> {
    return getDiff(this, other);
  }
}

export const recepturaResource: Resource<RevisionActions & CsvActions> = (
  client,
) => ({
  ...createRevisionClassResource("plm/receptura/", Receptura)(client),
  ...createCsvResource("plm/receptura_list.csv/")(client),
});
